import { Component, OnInit } from '@angular/core';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { FormGroup, FormControl, Validators, ReactiveFormsModule } from '@angular/forms';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { CategoryService } from 'src/app/shared/service/category/category.service';
import { ToastrService } from 'ngx-toastr';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';


@Component({
  selector: 'app-add-sample',
  imports: [CardComponent, ReactiveFormsModule, EditorComponent, NgSelectModule],
  templateUrl: './add-sample.component.html',
  styleUrl: './add-sample.component.scss'
})
export class AddSampleComponent implements OnInit {


  // TinyMCE API Key
  tinyAPiKey = 'ftw8ue85reubs65rxmfj2d18ds4g34g3eqopodomlwyyie7u';

  // TinyMCE editor configuration
  tinymceConfig = {
    height: 500,
    menubar: true,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table paste code help wordcount'
    ],
    toolbar:
      'undo redo | formatselect | bold italic backcolor | ' +
      'alignleft aligncenter alignright alignjustify | ' +
      'bullist numlist outdent indent | removeformat | help'
  };

  // Category dropdown data
  categories: any[] = [];

  // Uploaded file list with metadata
  myFiles: any[] = [];

  // Reactive form for adding/editing a sample
  sampleForm = new FormGroup({
    categoryId: new FormControl(null),
    sampleCode: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    sample_images: new FormControl<File[]>([]),
    aboutSample: new FormControl('', [Validators.required]),
    description: new FormControl(''),
    ingredients: new FormControl(''),
    usageInstructions: new FormControl(''),
    videoLink: new FormControl(''),
    totalItems: new FormControl(0),
    maxIssueQuantityCustomer: new FormControl(0),
    maxIssueQuantityRetailer: new FormControl(0),
    maxIssueQuantityWholesaler: new FormControl(0),
    confirm: new FormControl(false, [Validators.requiredTrue]),
    videoTitle: new FormControl("")
  });

  // --------------------- CONSTRUCTOR ---------------------

  constructor(
    private categoryService: CategoryService,
    private sampleService: SampleService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private router: Router
  ) { }

  // --------------------- LIFECYCLE ---------------------

  ngOnInit(): void {
    this.getAllCategories();
  }

  // --------------------- METHODS ---------------------

  // ✅ Fetch all unblocked categories
  getAllCategories() {
    this.categoryService.allCategories({ isBlocked: false }).subscribe({
      next: (result) => {
        if (result.success) {
          this.categories = result.data;
          console.log(this.categories);
        }
      },
      error: (e) => {
        this.toastr.error(e);
      }
    });
  }

getFileDetails(event: Event) {
  const input = event.target as HTMLInputElement;

  if (input.files) {
    for (let i = 0; i < input.files.length; i++) {
      const file = input.files[i];
      if (
        file.type !== 'image/jpeg' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/png'
      ) {
        this.toastr.info("Only JPG, JPEG and PNG images are allowed.");
        continue;
      }

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.myFiles.push({
          file: file,
          name: file.name,
          type: file.type,
          size: file.size,
          url: e.target.result
        });
      };
      reader.readAsDataURL(file);
    }
  }
}


  // ✅ Removes selected image from list
  removeFile(index: number) {
    this.myFiles.splice(index, 1);
  }

  // ✅ Submits form and uploads sample data
  submit() {
    this.spinner.show();
    const data = new FormData();

    // Append images
    for (let i = 0; i < this.myFiles.length; i++) {
      data.append('sample_images', this.myFiles[i].file);
    }

    // Append form values
    data.append('categoryId', this.sampleForm.value.categoryId ?? '');
    data.append('sampleCode', this.sampleForm.value.sampleCode ?? '');
    data.append('name', this.sampleForm.value.name ?? '');
    data.append('aboutSample', this.sampleForm.value.aboutSample ?? '');
    data.append('description', this.sampleForm.value.description ?? '')
    data.append('ingredients', this.sampleForm.value.ingredients ?? '');
    data.append('usageInstructions', this.sampleForm.value.usageInstructions ?? '');
    data.append('videoLink', this.sampleForm.value.videoLink ?? '');
    data.append('totalItems', this.sampleForm.value.totalItems?.toString() ?? '0');
    data.append('maxIssueQuantityCustomer', this.sampleForm.value.maxIssueQuantityCustomer?.toString() ?? '0');
    data.append('maxIssueQuantityRetailer', this.sampleForm.value.maxIssueQuantityRetailer?.toString() ?? '0');
    data.append('maxIssueQuantityWholesaler', this.sampleForm.value.maxIssueQuantityWholesaler?.toString() ?? '0');
    data.append("videoTitle",this.sampleForm.value.videoTitle);


    this.sampleService.addSample(data).subscribe({
      next: (res: any) => {
        this.spinner.hide();
        if (res.success) {
          this.toastr.success(res.message, 'Success');
          this.router.navigate(['/sample']);
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (e: any) => {
        this.spinner.hide();
        this.toastr.error(e.message, 'Error');
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }

}
